import * as _ from 'lodash-es';
import { coalesceFilter } from '../data/data.functions';

const activityActionMap = {
    create: 'Created by',
    close: 'Closed by',
    update: 'Updated by'
};

export function getActivityTitle(activity) {
    var section = _.get(activity, 'section', false);
    var refId = _.get(activity, 'refId', 0);

    switch (section) {
        case 'scmcommit':
            return 'SCM Commit ' + _.get(activity, 'extendedData.new_version', '').slice(0, 7);
        case 'docmanfileversion':  // Create and updates
        case 'docmanfile':  // Deletes only
            var title = _.get(activity, 'extendedData.docmanFile.description',
                _.get(activity, 'extendedData.description', ''));
            var ver = _.get(activity, 'extendedData.versionNumber', 1);
            if (ver == 1) {
                return title;
            } else {
                return title + ' v' + ver;
            }
        case 'docmanfolder':
            return 'Folder' + coalesceFilter(activity, 'extendedData.folderPath', '', ' - ');
        case 'frspackage':
            return 'Package' + coalesceFilter(activity, 'extendedData.package_name', '', ' - ');
        case 'trackeritem':
            //Old and new code will have summary key in different case
            var prop = 'extendedData.summary';
            if (_.has(activity, 'extendedData.Summary')){
                 prop = 'extendedData.Summary';
            }
            return '[#' + refId + ']' + coalesceFilter(activity, prop, '', ' - ');
        case 'wiki':
            return coalesceFilter(activity, 'extendedData.pagename', '', null);
        case 'tracker':
            return refId + " - Tracker Admin";
        case 'trackersprint':
        case 'sprint':
            return activity.description;
        case 'trackerquery':
            return "Query: " + 
                activity.extendedData.queryName;
        case 'forummessage':
            return "Discussion message: " + 
                _.get(activity, 'user.unixName', '') + ' ' +
                activity.description;
        case 'project':
            // Special case for SCM merge - saved in activity with vague data
            if (_.get(activity, 'activityType', '') == 'merge') {
                var title = _.get(activity, 'description', '')
                    .replace(
                        _.get(activity, 'user.unixName', '') + ' merged ',
                        'Merge '
                    );
                return title;
            }
            return "Project: " + _.get(activity, 'project.name', '') + '(' + _.get(activity, 'project.unixName', '') + ')';
        case 'build':
            return activity.description;
        default: //includes user
            return refId + ' - Changes';
    }
};

export function getActivityTitleDetail(activity) {
    var section = _.get(activity, 'section', '');

    switch (section) {
        case 'wiki':
        case 'wikipage':
        case 'wikiversion':
            return 'Wiki';
        case 'scmcommit':
            return 'Code';
        case 'build':
        case 'job':
        case 'cruisecontrol':
        case 'cruisecontrolbuild':
            return 'Builds';
        case 'file':
        case 'docmanfile':
        case 'docmanfileversion':
        case 'docmanfolder':
            return 'Documents';
        case 'frspackage':
        case 'frsrelease':
            return 'Releases';
        case 'sprint':
        case 'trackersprint':
            return 'Sprints';
        case 'trackeritem':
        case 'tracker':
        case 'trackerquery':
            // Handle old and new code versions
            var label = _.get(activity, 'extendedData.tracker.trackerName',
                _.get(activity, 'extendedData.tracker_name', 'Unknown')
            );
            return label + ' Tracker';
        default: // includes user
            // Special case for SCM merge
            if (_.get(activity, 'activityType', '') == 'merge') {
                return 'Code';
            }
            return _.get(activity, 'project.name', '');
    }
};

export function getActivityFooterText(activity, showProject) {
    var projectName = _.get(activity, 'project.name', '');
    var details = getActivityTitleDetail(activity);

    if (projectName != details && 
        projectName != showProject) {
        return "in " + projectName + ' / ' + details;
    }
    return "in " + details;
};

export function getActivityAction(action?: string): string {
    const key: string = action ?? '';
    return _.get(activityActionMap, key, 'By ');
};

export function getActivityDescription(activity?: any) {
    var section = _.get(activity, 'section', '');

    switch (section) {
        case 'build':
            return _.get(activity, 'extendedData.description', '');
        case 'docman':
        case 'docmanfile':
        case 'docmanfileversion':
            return _.get(activity, 'description', false);
        case 'scmcommit':
            return _.get(activity, 'extendedData.messageLog', '');
        case 'wiki':
        case 'wikipage':
            return _.get(activity, 'description', false);
        case 'trackeritem':
            if (activity.activityType === 'create') {
                //Old gforge and NEXT store the extendedData keys in different cases
                var details = _.get(activity, 'extendedData.details',
                    _.get(activity, 'extendedata.Details', false)
                );
                if (details) {
                    return details.replace(new RegExp("^<p>"), '')
                        .replace(new RegExp("<\/p>$"), '');
                }
            }
        default: //includes trackeritem
            return activity?.description;
    }
};

export function getActivityGlyphSection(activity?: any) {
    if (_.get(activity, 'activityType', '') == 'merge') {
        return 'scmcommit';
    }
    return _.get(activity, 'section', 'project');
};

export const activityImageClassMap = {
    wiki: 'glyphicon-book',
    scmcommit: 'glyphicon-random',
    user: 'glyphicon-user',
    file: 'glyphicon-file'
};

export function getActivityImageClass(section) {
    return _.get(activityImageClassMap, section, 'glyphicon-check');
};

export function getActivityItemState(activity) {
    if (_.get(activity, 'activityType', '') == 'delete') {
        return '.';
    }

    var projectId = _.get(activity, 'project.unixName',
        _.get(activity, 'projectId', false)
    );
    if (projectId) {
        projectId = "'" + projectId + "'";
    }
    var section = _.get(activity, 'section', '');

    switch (section) {
        case 'wiki':
        case 'wikipage':
            return 'home.project.summary.wiki.page({ pagename: "' + _.get(activity, 'extendedData.pagename', '') + '" })';
        case 'scmcommit':
        case 'scm':
            if (_.get(activity, 'extendedData', false)) {
                return "home.project.summary.scm.commit({unixName: " + projectId + ", commithash: '" + _.get(activity, 'extendedData.new_version', '') + "'})";
            }
            return 'home.project.summary.scm';
        case 'tracker':
            return 'home.project.summary.tracker.browse({ tracker: ' + activity.refId + ', unixName: ' + projectId + '})';
        case 'trackeritem':
            if (_.get(activity, 'extendedData', false)) {
                // Old format, new format
                var trackerId = _.get(activity, 'extendedData.TrackerId',
                    _.get(activity, 'extendedData.tracker.id', false)
                );
                // Old format, new format
                var trackerItemId = _.get(activity, 'extendedData.TrackerItemId',
                    _.get(activity, 'extendedData.id', false)
                );

                if (trackerId && trackerItemId) {
                    return 'home.project.summary.tracker.item.edit({ tracker: ' + trackerId + ', id: ' + trackerItemId + ', unixName: ' + projectId + '})';
                }
            }
            return ".";
        case 'forummessage':
            if (_.get(activity, 'extendedData', false)) {
                var forumId = _.get(activity, 'extendedData.id', false);
                if (forumId) {
                    return 'home.project.summary.forum.read({ id: ' + forumId + ', unixName: ' + projectId + '})';
                }
                return 'home.project.summary.forum({ unixName: ' + projectId + '})';
            }
            return ".";
        case 'project':
            return "home.project.summary({ unixName: '" + activity.refId + "'})";
        case 'build':
            return "home.project.summary.builds.detail({id: '" + _.get(activity, 'extendedData.id', 0) + "'})";
        case 'docmanfileversion':
            var path: string = _.get(activity, 'extendedData.folderPath', ''),
                unixName: string = _.get(activity, 'extendedData.docmanFile.folders[0].project.unixName', '');

            return "home.project.summary.docman({unixName: '" + unixName + "', path: '" + path + "'})";
        case 'docmanfolder':
            var path: string = _.get(activity, 'extendedData.folderPath', ''),
                unixName: string = _.get(activity, 'extendedData.project.unixName', '');

            return "home.project.summary.docman({unixName: '" + unixName + "', path: '" + path + "'})";

        default: //includes user
            return ".";
    };
};

export function getActivitySectionState(activity) {
    var section = _.get(activity, 'section', '');

    switch (section) {
        case 'scmcommit':
        case 'scm':
            return 'home.project.summary.scm';
        case 'tracker':
            return 'home.project.summary.tracker.browse({ tracker: ' + activity.refId + ', unixName: ' + activity.projectId + '})';
        case 'trackeritem':
            var projectId = _.get(activity, 'project.unixName', activity.projectId);
            var tracker_id = _.get(activity.extendedData,
                'tracker_id',
                _.get(activity.extendedData, 'tracker.id', false)
            );
            if (tracker_id) {
                return 'home.project.summary.tracker.browse({ tracker: ' + tracker_id + ', unixName: ' + projectId + '})';
            }
            return ".";
        case 'project':
            return 'home.project.summary({ unixName: ' + activity.refId + '})';
        default: //includes user
            return ".";
    };
};

export function getActivityUserState(activity: any): string {
    var unixName = _.get(activity, 'user.unixName', false);

    if (unixName) {
        return 'home.user.userhome({ unixName: "' + unixName + '"})';
    }
    return null;
};


/**
 * Determines the state name for a given activity based on its type and section.
 * 
 * @param activity - The activity object containing information about the action
 * @returns A string representing the state name in dot notation format
 */
export function getActivityItemStateName(activity: any): string {
    // If activity type is "delete," return "."
    if (_.get(activity, 'activityType', '') === 'delete') {
      return '.';
    }
  
    const section = _.get(activity, 'section', '');
  
    switch (section) {
      case 'wiki':
      case 'wikipage':
        return 'home.project.summary.wiki.page';

      case 'scmcommit':
      case 'scm':
        if (_.get(activity, 'extendedData', false)) {
          return 'home.project.summary.scm.commit';
        }
        return 'home.project.summary.scm';
  
      case 'tracker':
        return 'home.project.summary.tracker.browse';
  
      case 'trackeritem':
        if (_.get(activity, 'extendedData', false)) {
          // If we have extendedData for tracker item
          return 'home.project.summary.tracker.item.edit';
        }
        return '.';
  
      case 'forummessage':
        if (_.get(activity, 'extendedData', false)) {
          // If we have extendedData for forum
          const forumId = _.get(activity, 'extendedData.id', false);
          if (forumId) {
            return 'home.project.summary.forum.read';
          }
          return 'home.project.summary.forum';
        }
        return '.';
  
      case 'project':
        return 'home.project.summary';
  
      case 'build':
        return 'home.project.summary.builds.detail';
  
      case 'docmanfileversion':
      case 'docmanfolder':
        return 'home.project.summary.docman';
  
      default:
        // includes 'user' or anything else
        return '.';
    }
}


/**
 * Retrieves state parameters for a given activity item based on its section type.
 * 
 * @param activity - The activity object containing information about the action performed
 * @returns A record object containing state parameters specific to the activity section
 */
export function getActivityItemStateParams(activity: any): Record<string, any> {
    // If activity type is "delete," no real params needed
    if (_.get(activity, 'activityType', '') === 'delete') {
      return {};
    }
  
    let projectId = _.get(activity, 'project.unixName', _.get(activity, 'projectId', ''));

    const section = _.get(activity, 'section', '');
  
    switch (section) {
      case 'wiki':
      case 'wikipage': {
        const params: Record<string, any> = {
          pagename: _.get(activity, 'extendedData.pagename', ''),
        };
        // Only pin the project when we know its unixName; otherwise let UI-Router inherit the
        const wikiProject = _.get(activity, 'project.unixName', '');
        if (wikiProject) {
          params.unixName = wikiProject;
        }
        return params;
      }

      case 'scmcommit':
      case 'scm': {
        if (_.get(activity, 'extendedData', false)) {
          return {
            unixName: projectId,
            commithash: _.get(activity, 'extendedData.new_version', ''),
          };
        }
        return {};
      }
  
      case 'tracker':
        return {
          tracker: _.get(activity, 'refId', ''),
          unixName: projectId,
        };
  
      case 'trackeritem': {
        if (_.get(activity, 'extendedData', false)) {
          const trackerId = _.get(
            activity,
            'extendedData.TrackerId',
            _.get(activity, 'extendedData.tracker.id', false)
          );
          const trackerItemId = _.get(
            activity,
            'extendedData.TrackerItemId',
            _.get(activity, 'extendedData.id', false)
          );
          if (trackerId && trackerItemId) {
            return {
              tracker: trackerId,
              id: trackerItemId,
              unixName: projectId,
            };
          }
        }
        return {};
      }
  
      case 'forummessage': {
        if (_.get(activity, 'extendedData', false)) {
          const forumId = _.get(activity, 'extendedData.id', false);
          if (forumId) {
            return {
              id: forumId,
              unixName: projectId,
            };
          }
          return {
            unixName: projectId,
          };
        }
        return {};
      }
  
      case 'project':
        return {
          unixName: _.get(activity, 'refId', ''),
        };
  
      case 'build':
        return {
          id: _.get(activity, 'extendedData.id', 0),
        };
  
      case 'docmanfileversion': {
        const path = _.get(activity, 'extendedData.folderPath', '');
        const unixName = _.get(
          activity,
          'extendedData.docmanFile.folders[0].project.unixName',
          ''
        );
        return {
          path,
          unixName,
        };
      }
  
      case 'docmanfolder': {
        const path = _.get(activity, 'extendedData.folderPath', '');
        const unixName = _.get(activity, 'extendedData.project.unixName', '');
        return {
          path,
          unixName,
        };
      }
  
      default:
        return {};
    }
}

